module.exports = __webpack_public_path__ + "img/alu_1.c239f32a.webp";